/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} RestoreInputs */

const en_restore = /** @type {(inputs: RestoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restore`)
};

const ar_restore = /** @type {(inputs: RestoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إستعادة`)
};

const de_restore = /** @type {(inputs: RestoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiederherstellen`)
};

const es_restore = /** @type {(inputs: RestoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restablecer`)
};

const fr_restore = /** @type {(inputs: RestoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restaurer`)
};

const it_restore = /** @type {(inputs: RestoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ripristina`)
};

const ja_restore = /** @type {(inputs: RestoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`復元`)
};

const ko_restore = /** @type {(inputs: RestoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`복구`)
};

const pt_br_restore = /** @type {(inputs: RestoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restaurar`)
};

const ru_restore = /** @type {(inputs: RestoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Восстановить`)
};

const th_restore = /** @type {(inputs: RestoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กู้คืน`)
};

const tr_restore = /** @type {(inputs: RestoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geri al`)
};

const zh_cn_restore = /** @type {(inputs: RestoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`恢复`)
};

const zh_tw_restore = /** @type {(inputs: RestoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`還原`)
};

/**
* | output |
* | --- |
* | "Restore" |
*
* @param {RestoreInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const restore = /** @type {((inputs?: RestoreInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<RestoreInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_restore(inputs)
	if (locale === "ar") return ar_restore(inputs)
	if (locale === "de") return de_restore(inputs)
	if (locale === "es") return es_restore(inputs)
	if (locale === "fr") return fr_restore(inputs)
	if (locale === "it") return it_restore(inputs)
	if (locale === "ja") return ja_restore(inputs)
	if (locale === "ko") return ko_restore(inputs)
	if (locale === "pt_br") return pt_br_restore(inputs)
	if (locale === "ru") return ru_restore(inputs)
	if (locale === "th") return th_restore(inputs)
	if (locale === "tr") return tr_restore(inputs)
	if (locale === "zh_cn") return zh_cn_restore(inputs)
	return zh_tw_restore(inputs)
});